// removed by extract-text-webpack-plugin
module.exports = {"Container":"currentMembers__Container__3CgXb","Avatar":"currentMembers__Avatar__XXtTv","Active":"currentMembers__Active__2o4UZ","Passive":"currentMembers__Passive__2miCV","Expanded":"currentMembers__Expanded__2nXEj","Collapsed":"currentMembers__Collapsed__3H5OC","Title":"currentMembers__Title__2CGoi","RoomDetail":"currentMembers__RoomDetail__3ONtA","RoomDetailText":"currentMembers__RoomDetailText__ESSYe","RoomDetailValue":"currentMembers__RoomDetailValue__1Ec_f"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/CurrentMembers/currentMembers.css
// module id = 876
// module chunks = 2